import { NgModule } from '@angular/core';
import { FuseSidebarModule } from './../../../../@fuse/components/sidebar/sidebar.module';
import { FuseSharedModule } from './../../../../@fuse/shared.module';
import { ChatPanelModule } from './../../components/chat-panel/chat-panel.module';
import { ContentModule } from './../../components/content/content.module';
import { FooterModule } from './../../components/footer/footer.module';
import { NavbarModule } from './../../components/navbar/navbar.module';
import { QuickPanelModule } from './../../components/quick-panel/quick-panel.module';
import { ToolbarModule } from './../../components/toolbar/toolbar.module';
import { VerticalLayout1Component } from './../../vertical/layout-1/layout-1.component';
import { FuseChatPanelComponentDynamic } from '../../components/chat-panel-dynamic/chat-panel-dynamic.component';
import { SidePanelModule } from '../../components/side-panel-dynamic/side-panel.module';
import { DeviceZoomControlComponent } from '../../components/device-zoom-control/device-zoom-control.component';
import { PlatformBreadCrumbModule } from '../../../../../app-platform-breadcrumb';
import { PlatformBreadcrumbSharedModule } from '../../../../../app-platform-breadcrumb-shared-module';
@NgModule({
    declarations: [VerticalLayout1Component, FuseChatPanelComponentDynamic, DeviceZoomControlComponent],
    imports: [
        // RouterModule,
        FuseSharedModule,
        FuseSidebarModule,
        ChatPanelModule,
        ContentModule,
        FooterModule,
        NavbarModule,
        QuickPanelModule,
        SidePanelModule,
        ToolbarModule,
        PlatformBreadCrumbModule,
        PlatformBreadcrumbSharedModule
    ],
    exports: [VerticalLayout1Component]
})
export class VerticalLayout1Module {}
